import React from 'react'
import ReactTooltip from 'react-tooltip'

const TooltipBuyer = React.memo(({ id, toolTipText }) => {
  return (
    <ReactTooltip
      id={id}
      place="bottom"
      effect="solid"
      className="background-white"
    >
      {toolTipText}
    </ReactTooltip>
  )
})

export default TooltipBuyer
